import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRequestForm,
  saveRequestForm,
} from "../../../../redux/slices/requestForm";
import SideBar from "../../SideBar";
import Notification from "../components/Notification";
import Title from "../components/Title";
import { REQUEST_FIELDS } from "../components/request-fields";

export default function RequestFormSettings() {
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.requestForm.settings);

  const [form, setForm] = useState(saved);
  const [saving, setSaving] = useState(false);
  const [show, setShow] = useState(false);
  const [notif, setNotif] = useState({ text: "", subText: "", state: "success" });

  useEffect(() => {
    dispatch(fetchRequestForm());
  }, [dispatch]);

  // подхватываем то, что пришло с сервера
  useEffect(() => {
    setForm(saved);
  }, [saved]);

  const notify = (text, state, subText = "") => {
    setNotif({ text, subText, state });
    setShow(true);
    setTimeout(() => setShow(false), 3500);
  };

  const toggle = (key) => setForm((prev) => ({ ...prev, [key]: !prev[key] }));

  const handleSave = async () => {
    if (!form.phone && !form.email) {
      notify(
        "Оставьте телефон или email",
        "warn",
        "Иначе клиент не сможет отправить заявку — нужен хотя бы один способ связи."
      );
      return;
    }

    setSaving(true);
    try {
      await dispatch(saveRequestForm(form)).unwrap();
      notify("Настройки сохранены!", "success", "Форма на сайте уже обновилась.");
    } catch (error) {
      notify("Ошибка сохранения", "error", "Попробуйте ещё раз.");
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SideBar>
      <Notification
        show={show}
        setShow={setShow}
        text={notif.text}
        subText={notif.subText}
        state={notif.state}
      />
      <Title text="Форма заявки" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 py-4">
        <div className="max-w-2xl rounded-xl border border-neutral-200 shadow-lg bg-white p-6">
          <p className="text-sm text-neutral-500">
            Отметьте, какие поля видит клиент в окне «Оставить заявку». Имя и
            фамилия спрашиваются всегда.
          </p>

          <div className="mt-5 flex flex-col gap-1">
            {REQUEST_FIELDS.map((field) => (
              <label
                key={field.key}
                className={`flex items-start gap-3 rounded-lg px-3 py-3 cursor-pointer hover:bg-neutral-50 ${
                  field.indent ? "ml-6 border-l-2 border-neutral-200" : ""
                }`}
              >
                <input
                  type="checkbox"
                  checked={Boolean(form[field.key])}
                  onChange={() => toggle(field.key)}
                  className="mt-0.5 h-4 w-4 rounded border-neutral-300 text-sky-600 focus:ring-sky-500"
                />
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-neutral-900">
                    {field.label}
                  </span>
                  {field.hint && (
                    <span className="block text-sm text-neutral-500">
                      {field.hint}
                    </span>
                  )}
                </span>
              </label>
            ))}
          </div>

          <div className="mt-6 flex justify-end">
            <button
              type="button"
              onClick={handleSave}
              disabled={saving}
              className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-sky-600 hover:bg-sky-500 disabled:opacity-60"
            >
              {saving ? "Сохраняем…" : "Сохранить"}
            </button>
          </div>
        </div>
      </div>
    </SideBar>
  );
}
